module.exports = __webpack_public_path__ + "img/img-7-mobile.586ddfe1.png";